import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import { Drawer } from 'site-modules/shared/components/drawer/drawer';
import { DrawerCloseButton } from 'site-modules/shared/components/drawer/drawer-close-button/drawer-close-button';
import { sellYourCarConfigParams } from 'client/data/models/dealer-info';
import { AppraisalReportStep } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/appraisal-report-step/appraisal-report-step';
import { LocationAndStyleStep } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/location-and-style-step/location-and-style-step';

import { TradeInAppraiserAsync } from './trade-in-appraiser-async';

export const TradeInAppraiserDrawer = ({
  isOpen,
  onToggle,
  onTradeInUpdate = null,
  onVehicleUpdate = null,
  trackingParent,
  sellYourCarConfig = {},
  drawerClassNames = null,
  isPurchase = false,
  sellingPrice = 0,
  msrp = 0,
  residualValue = 0,
  isUsed = false,
  dataTest = '',
  isContrastUpdate = false,
  displayTradeInValues = true,
}) => {
  const [isDrawerComponentLoaded, setIsDrawerComponentLoaded] = useState(false);

  if (isOpen && !isDrawerComponentLoaded) {
    setIsDrawerComponentLoaded(true);
  }

  return (
    <Drawer
      side="right"
      data-tracking-parent={trackingParent}
      classNames={{ drawerContent: 'px-0_5', drawer: drawerClassNames }}
      toggle={onToggle}
      isOpen={isOpen}
      data-test={dataTest}
    >
      <DrawerCloseButton
        onClick={onToggle}
        className="mb-0 mb-md-2_5 d-block px-md-2 px-lg-3_5 text-end text-md-start"
        lgBtnClass="ps-0"
        smBtnClass="d-inline-block"
        trackingId="close_report"
        trackingValue="x upper right"
      />
      {isDrawerComponentLoaded && (
        <Container className="mx-0 px-0">
          <TradeInAppraiserAsync
            onDone={onToggle}
            onTradeInUpdate={onTradeInUpdate}
            onVehicleUpdate={onVehicleUpdate}
            className="px-1 px-md-2 px-lg-3_5"
            sellYourCarConfig={sellYourCarConfig}
            isPurchase={isPurchase}
            sellingPrice={sellingPrice}
            msrp={msrp}
            residualValue={residualValue}
            isUsed={isUsed}
            drawerCreativeId={trackingParent}
            isContrastUpdate={isContrastUpdate}
            displayTradeInValues={displayTradeInValues}
            scrollToOnApply={null}
            ReportStep={AppraisalReportStep}
            LocationAndStyleStepComponent={LocationAndStyleStep}
          />
        </Container>
      )}
    </Drawer>
  );
};

TradeInAppraiserDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onTradeInUpdate: PropTypes.func,
  onVehicleUpdate: PropTypes.func,
  trackingParent: PropTypes.string.isRequired,
  sellYourCarConfig: sellYourCarConfigParams,
  drawerClassNames: PropTypes.string,
  isPurchase: PropTypes.bool,
  sellingPrice: PropTypes.number,
  msrp: PropTypes.number,
  residualValue: PropTypes.number,
  isUsed: PropTypes.bool,
  dataTest: PropTypes.string,
  isContrastUpdate: PropTypes.bool,
  displayTradeInValues: PropTypes.bool,
};
